export const BuildInfo = {timestamp:1777581832000}
